<template>
  <div>
    <div class="flex mb-2">
      <select name="" id="" class="form-control"></select>
    </div>
    <div class="salary_type">
      <p>Низкая ставка з/п</p>
      <div class="flex">
        <div class="form-group">
          <label>ставка</label>
          <input v-model="salaryDetails.low.basic" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>% сумма</label>
          <input v-model="salaryDetails.low.rate" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(сумма-расходы) *</label>
          <input v-model="salaryDetails.low.expenses" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(ставка надбавки)</label>
          <input v-model="salaryDetails.low.bonus" type="number"
                 class="form-control">
        </div>
      </div>
    </div>
    <div class="salary_type">
      <p>Дальняя ставка</p>
      <div class="flex">
        <div class="form-group">
          <label>ставка</label>
          <input v-model="salaryDetails.mid.basic" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>% сумма</label>
          <input v-model="salaryDetails.mid.rate" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(сумма-расходы) *</label>
          <input v-model="salaryDetails.mid.expenses" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(ставка надбавки)</label>
          <input v-model="salaryDetails.mid.bonus" type="number"
                 class="form-control">
        </div>
      </div>
    </div>
    <div class="salary_type">
      <p>Высокая ставка з/п</p>
      <div class="flex">
        <div class="form-group">
          <label>ставка</label>
          <input v-model="salaryDetails.high.basic" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>% сумма</label>
          <input v-model="salaryDetails.high.rate" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(сумма-расходы) *</label>
          <input v-model="salaryDetails.high.expenses" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(ставка надбавки)</label>
          <input v-model="salaryDetails.high.bonus" type="number"
                 class="form-control">
        </div>
      </div>
    </div>
    <div class="salary_type">
      <p>Индивидуальная ставка з/п (вся сумма доставки курьеру)</p>
      <div class="flex">
        <div class="form-group">
          <label>ставка</label>
          <input v-model="salaryDetails.personal.basic" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>% сумма</label>
          <input v-model="salaryDetails.personal.rate" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(сумма-расходы) *</label>
          <input v-model="salaryDetails.personal.expenses" type="number"
                 class="form-control">
        </div>
        <span>+</span>
        <div class="form-group">
          <label>(ставка надбавки)</label>
          <input v-model="salaryDetails.personal.bonus" type="number"
                 class="form-control">
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['salaryDetails', 'currencyId'],
  currencies: [],
  created() {
    if (!this.salaryDetails.personal) {
      this.salaryDetails.personal = {rate: 0, basic: 0, bonus: 0, expenses: 0};
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 1px;
}

.flex {
  padding: 0 10px;
  padding-top: 5px;
}

.salary_type {
  border: 1px solid lightgray;
  padding-bottom: 6px;
  margin: 5px 0;
}
</style>
